

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import { pathwayTypeInfoType } from '@/types/Information';

@Component
export default class FinalDecisionOnLeaveToAppealRspToLeaveRefusedPg extends Vue {  

    @informationState.Action
    public UpdatePathType!:(newPathType: pathwayTypeInfoType) => void

    public resToLeaveGrantedPath() {
        
        const pathType = {} as pathwayTypeInfoType;
        pathType.rspToLeaveGranted = true;
        this.UpdatePathType(pathType);        
        this.$emit('closeWindow');

    }

    public resToLeaveRefusedFinalPath() {

        const pathType = {} as pathwayTypeInfoType;
        pathType.rspToLeaveRefusedFinal = true;
        this.UpdatePathType(pathType);
        this.$emit('closeWindow');
    }
}
